import { memo, type PropsWithChildren, useContext } from 'react';
import styled from 'styled-components';

import colors from '@wecasa/common/src/utils/colors';
import { toRem } from '@wecasa/common/src/utils/styles';

import type { WithClassNameProps } from '@wecasa/web-ui/src/components/types';
import { DesktopAndTablet, Mobile } from '@wecasa/web-ui/src/styles/media-queries';

import BasketContext from '../main-container/basket-context';
import DesktopNavigation from './desktop-navigation';
import MobileNavigation, { NAVIGATION_CONTAINER_MOBILE_HEIGHT } from './mobile-navigation';

export const NAVIGATION_CONTAINER_BOTTOM_PADDING = NAVIGATION_CONTAINER_MOBILE_HEIGHT + 10;

const Container = styled.div.attrs({
  role: 'navigation',
})`
  display: flex;
  justify-content: center;
  align-items: baseline;
  width: 100%;
`;

const MobileRelativeContainer = styled(Container)`
  position: relative;
  border: 0;
  background-color: ${colors.transparent};
  margin-top: ${toRem(20)};
`;

type NavigationContainerProps = WithClassNameProps & PropsWithChildren<{}>;

const NavigationContainer = ({ children, className }: NavigationContainerProps) => {
  const { show: showBasket } = useContext(BasketContext);
  return (
    <>
      <DesktopAndTablet>
        <DesktopNavigation className={className} showBasket={showBasket}>
          {children}
        </DesktopNavigation>
      </DesktopAndTablet>
      <Mobile>
        {showBasket ? (
          <MobileNavigation>{children}</MobileNavigation>
        ) : (
          <MobileRelativeContainer>{children}</MobileRelativeContainer>
        )}
      </Mobile>
    </>
  );
};

export default memo(NavigationContainer);
